module.exports = __webpack_public_path__ + "media/images/team_wecasa-25c47c2edd5a51b4928ce35154a6789d.jpg";